import { lazy, Suspense, useCallback, useRef } from 'react';
import { CircularProgress, Typography, Button } from '@material-ui/core';
import { Fragment } from 'react/jsx-runtime';
import { EditProfileSideInfoContentContainer, EditProfileSideInfoLoading } from './EditProfileSideInfoModal.styles';
import { COLORS } from 'shared/constants/COLORS';
import { useEditProfileMediaBin } from '../../hooks/useEditProfileMediaBin';
import { useEditProfilePhotoEditor } from '../../context/EditProfilePhotoEditorV2Provider';
import { EPhotoEditorConsumer } from 'shared/enums/EPhotoEditorConsumer';
import DialogInfo from 'components/DialogInfo/DialogInfo';
const MediaBinModalLazy = lazy(() => import('shared/components/MediaBinModal/MediaBinModal'));

type EditProfileSideInfoModalProps = {
  open: boolean;
  handleOpen: VoidFunction;
};

const EditProfileSideInfoModal = ({ open, handleOpen }: EditProfileSideInfoModalProps) => {
  const buttonStyle = { background: 'transparent', border: `1px solid ${COLORS.PRIMARY}` };
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const { handlePhotoEditorOpen } = useEditProfilePhotoEditor();

  const { openMediaBin, addMedia, isLoading, handleOpenMediaBin } = useEditProfileMediaBin(() => {
    handleOpen();
  });

  const handleNewUploadClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    handleOpen();
    if (event.target.files) {
      const filesArray = Array.from(event.target.files);
      handlePhotoEditorOpen(filesArray, EPhotoEditorConsumer.PROFILE_SIDE_INFO);
    }
  }, []);

  return (
    <Fragment>
      <DialogInfo openDialog={open} handleDialog={handleOpen} title={'Change Primary Image'}>
        <EditProfileSideInfoContentContainer>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
            accept="image/*"
          />
          {isLoading ? (
            <EditProfileSideInfoLoading>
              <CircularProgress size={12} />
              <Typography>Uploading Media...</Typography>
            </EditProfileSideInfoLoading>
          ) : (
            <Fragment>
              <Button style={buttonStyle} variant="outlined" size="large" onClick={handleOpenMediaBin}>
                Select From Media Bin
              </Button>
              <Button style={buttonStyle} variant="outlined" size="large" onClick={handleNewUploadClick}>
                Upload New Image
              </Button>
            </Fragment>
          )}
        </EditProfileSideInfoContentContainer>
      </DialogInfo>
      {openMediaBin ? (
        <Suspense fallback={''}>
          <MediaBinModalLazy
            single
            showOnly={['image']}
            selected={[]}
            show={openMediaBin}
            close={handleOpenMediaBin}
            setSelected={addMedia}
          />
        </Suspense>
      ) : null}
    </Fragment>
  );
};

export default EditProfileSideInfoModal;
